module.exports = __webpack_public_path__ + "media/images/eu500-fdf361aa0704156de58ea72f6255f6dc.svg";